"use strict";
// Pure, React-free helpers for turning a flat GroupNode[] (as returned by the hierarchy API)
// into a tree the sidebar can render. No fetching here — see GroupTreeSidebar.tsx for the
// presentational component and each app's groupHierarchyApi for the actual requests.
Object.defineProperty(exports, "__esModule", { value: true });
exports.countSubtree = exports.isDescendant = exports.findNode = exports.flattenVisible = exports.buildTree = void 0;
/** Assemble a flat, unordered node list into a forest of GroupTreeNode roots, sorted by name. */
function buildTree(nodes) {
    const byId = new Map();
    for (const n of nodes) {
        byId.set(n.id, { ...n, children: [] });
    }
    const roots = [];
    for (const n of byId.values()) {
        if (n.parentGroupId && byId.has(n.parentGroupId)) {
            byId.get(n.parentGroupId).children.push(n);
        }
        else {
            roots.push(n);
        }
    }
    const sortByName = (a, b) => a.name.localeCompare(b.name);
    const sortRecursive = (list) => {
        list.sort(sortByName);
        for (const child of list)
            sortRecursive(child.children);
    };
    sortRecursive(roots);
    return roots;
}
exports.buildTree = buildTree;
/** Flatten a tree to just the nodes visible given a set of expanded node ids (collapsed branches omitted). */
function flattenVisible(tree, expandedIds) {
    const out = [];
    const walk = (nodes) => {
        for (const node of nodes) {
            out.push(node);
            if (node.children.length > 0 && expandedIds.has(node.id)) {
                walk(node.children);
            }
        }
    };
    walk(tree);
    return out;
}
exports.flattenVisible = flattenVisible;
/** Find a node by id anywhere in the tree, or null if absent. */
function findNode(tree, id) {
    for (const node of tree) {
        if (node.id === id)
            return node;
        const found = findNode(node.children, id);
        if (found)
            return found;
    }
    return null;
}
exports.findNode = findNode;
/** True if `descendantId` is anywhere beneath `ancestorId` in the tree (or is the same node). */
function isDescendant(tree, ancestorId, descendantId) {
    const ancestor = findNode(tree, ancestorId);
    if (!ancestor)
        return false;
    if (ancestor.id === descendantId)
        return true;
    return findNode(ancestor.children, descendantId) !== null;
}
exports.isDescendant = isDescendant;
/** Total node count in a subtree, including the node itself. */
function countSubtree(node) {
    return 1 + node.children.reduce((sum, child) => sum + countSubtree(child), 0);
}
exports.countSubtree = countSubtree;
